/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendListBaseFilters extends models.InfraResourceTrendSummaryBaseFilters {
    getFixupPrototypeFunction() { return InfraResourceTrendListBaseFilters.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendListBaseFilters>): InfraResourceTrendListBaseFilters {
        let obj = Object.assign(new InfraResourceTrendListBaseFilters(), model);
        InfraResourceTrendListBaseFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendListBaseFilters>): InfraResourceTrendListBaseFilters {
        if (!model) return null;
        return InfraResourceTrendListBaseFilters.newInstance(<InfraResourceTrendListBaseFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendListBaseFilters) {
        if (!obj) return;

        models.InfraResourceTrendListBaseFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendListBaseFilters): boolean {
        if (models.InfraResourceTrendSummaryBaseFilters.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraResourceTrendListBaseFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Search based on resource category, resource type,resource name or resource ID.
     */
    search: string;

}
